import { DefaultValueGetter, InitEntries } from '../types/map-with-default';

class MapWithDefault<K, V> extends Map<K, V> {
    private readonly _defaultValueGetter: DefaultValueGetter<K, V>;

    constructor(defaultValueGetter: DefaultValueGetter<K, V>, entries?: InitEntries<K, V>) {
        super(entries);
        this._defaultValueGetter = defaultValueGetter;
    }

    get(key: K): V {
        return super.get(key) || this._defaultValueGetter(key);
    }
}

export { MapWithDefault };
